import CityPageTemplate from "../city-template/CityPageTemplate";
import { janesvilleConfig } from "./data";

export default function JanesvillePage() {
  return <CityPageTemplate config={janesvilleConfig} />;
}